<template>
  <div>
    <section v-show="sidebarCurrentPanel === 'exibitionmode'" class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          {{ $t('general.labels.configurations') }}
        </header>
        <div class="submenu-content sub-color">
          <advanced-config-header></advanced-config-header>
          <advanced-config-options></advanced-config-options>
          <a
            href="#"
            class="btn"
            @click="sidebarChangePanel('exibitionfrequency');">{{ $t('general.labels.next') }}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AdvancedConfigHeader from './Header.vue';
import AdvancedConfigOptions from './options/Main.vue';

export default {
  components: {
    AdvancedConfigHeader,
    AdvancedConfigOptions,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
  }),
  methods: mapActions([
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?497948c8
 **/